import { Component, EventEmitter, Input, OnInit, Output, ViewChild,} from "@angular/core";
import { CommonService } from "../../../../core/services/common.service";
import { httpStatusCodes } from "src/app/core/config/http-status-codes";
import { UntypedFormControl, UntypedFormGroup, Validators,} from "@angular/forms";
import { OtpVerificationComponent } from "../otp-verification/otp-verification.component";
import { JwtService } from "../../../../core/services/jwt.service";
import { VerificationService } from "../../verification.service";
import { IOtpVerificationParams } from "../../models/otp-verification-data.model";
import { verificationTypes } from "../../models/verification-types.model";

@Component({
  selector: "app-phone-verification-steps",
  templateUrl: "./phone-verification-steps.component.html",
  styleUrls: ["./phone-verification-steps.component.scss"],
  standalone: false,
})
export class PhoneVerificationStepsComponent implements OnInit {
  public verifyNowStep1: boolean = false;
  public sendOtpStep2: boolean = false;
  public verifyOtpStep3: boolean = false;
  public phoneNumberForm: UntypedFormGroup;
  public formError: any = {};
  public phoneValidatedStatus: boolean = false;
  public verificationLoader: boolean = false;
  public phoneVerificationData: IOtpVerificationParams;
  public showOtpComponent: boolean = false;
  private userId: number;

  @ViewChild("otpComponent", { static: false })
  otpCmp: OtpVerificationComponent;
  @Input() userDetails: {
    phone: string;
    verificationFrom: string;
    userId?: number;
    verificationToken?: string;
    countryCode: string;
  };
  @Input() loadingFrom: string = "";
  @Output() closeModal = new EventEmitter();
  @Output() phoneVerifiedSuccess = new EventEmitter();
  @Output() tokenExpiresEvent = new EventEmitter();
  constructor(
    private commonService: CommonService,
    private jwtService: JwtService,
    private verificationService: VerificationService,
  ) {}

  ngOnInit() {
    this.initForm();
    this.verifyNowStep1 = true;
    if (this.userDetails !== undefined) {
      this.userId = this.userDetails.userId;
      this.phoneNumberForm.patchValue({ phone: this.userDetails.phone });
    } else {
      this.userId = this.jwtService.getUserId();
    }
  }

  initForm() {
    this.phoneNumberForm = new UntypedFormGroup({
      phone: new UntypedFormControl(null, [
        Validators.required,
        Validators.minLength(9),
        Validators.maxLength(10),
        Validators.pattern(/^-?(0|[1-9]\d*)?$/),
      ]),
    });
  }

  sanitizePhoneNumber(event: Event) {
    const phoneControl = this.phoneNumberForm.get("phone");
    const input = event.target as HTMLInputElement;
    const sanitizedValue = (input.value || "").replace(/\D/g, "").slice(0, 10);

    if (input.value !== sanitizedValue) {
      input.value = sanitizedValue;
    }

    if (phoneControl && phoneControl.value !== sanitizedValue) {
      phoneControl.setValue(sanitizedValue);
    }

    this.clearPhoneServerError();
  }

  verifyNow() {
    this.verifyNowStep1 = false;
    this.sendOtpStep2 = true;
  }

  closeModel() {
    this.closeModal.emit("close");
  }

  sendOtp(form) {
    this.clearPhoneServerError();
    if (this.phoneNumberForm.valid) {
      const params = {
        verificationMethod: "phone",
        phone: this.phoneNumberForm.value.phone,
        countryCode: this.userDetails.countryCode,
        userId: this.userId,
        verificationToken: this.userDetails.verificationToken,
      };
      this.verificationLoader = true;
      if (
        this.userDetails.verificationFrom ===
        verificationTypes.forcePhoneVerification
      ) {
        this.verificationService
          .sendVerificationOtp(params, this.userDetails.verificationFrom)
          .subscribe(
            (res) => {
              const response = res;
              this.verificationLoader = false;
              try {
                if (response.status === httpStatusCodes.success) {
                  this.phoneVerificationData = {
                    otpId: response.data.otpId,
                    phone: form.value.phone,
                    countryCode: this.userDetails.countryCode,
                    email: "",
                    verificationMethod: "phone",
                    verificationToken: this.userDetails.verificationToken,
                  };
                  this.sendOtpStep2 = false;
                  this.verifyOtpStep3 = true;
                  this.showOtpComponent = true;
                  setTimeout(() => {
                    this.otpCmp.resetTimer(60);
                  }, 1000);
                }
              } catch (e) {
                this.commonService.commonSnakeBar();
              }
            },
            (err) => {
              const error = err;
              this.verificationLoader = false;
              if (error.data.data === "tokenExpires") {
                this.tokenExpiresEvent.emit("true");
              }
              if (error.status === httpStatusCodes.formError) {
                const phoneErrorMessage =
                  (error.errors && (error.errors.phone || error.errors.phoneNo)) ||
                  error.message ||
                  "Invalid number. Please enter a valid phone number.";
                this.setPhoneServerError(phoneErrorMessage);
              } else if (error.message) {
                this.commonService.showSnakeBar(error.message);
              } else {
                this.commonService.showSnakeBar(
                  "Invalid number. Please enter a valid phone number.",
                );
              }
            },
          );
      } else {
        this.verificationService
          .sendVerificationOtp(params, this.userDetails.verificationFrom)
          .subscribe(
            (res) => {
              const response = res;
              this.verificationLoader = false;
              try {
                if (response.status === httpStatusCodes.success) {
                  this.phoneVerificationData = {
                    otpId: response.data.otpId,
                    phone: form.value.phone,
                    countryCode: this.userDetails.countryCode,
                    email: "",
                    verificationMethod: "phone",
                  };
                  this.sendOtpStep2 = false;
                  this.verifyOtpStep3 = true;
                  this.showOtpComponent = true;
                  setTimeout(() => {
                    this.otpCmp.resetTimer(60);
                  }, 1000);
                }
              } catch (e) {
                this.commonService.commonSnakeBar();
              }
            },
            (err) => {
              const error = err;
              this.verificationLoader = false;
              if (error.status === httpStatusCodes.formError) {
                const phoneErrorMessage =
                  (error.errors && (error.errors.phone || error.errors.phoneNo)) ||
                  error.message ||
                  "Invalid number. Please enter a valid phone number.";
                this.setPhoneServerError(phoneErrorMessage);
              } else if (error.message) {
                this.commonService.showSnakeBar(error.message);
              } else {
                this.commonService.showSnakeBar(
                  "Invalid number. Please enter a valid phone number.",
                );
              }
            },
          );
      }
    }
  }

  otpResponse(event) {
    if (event.status === "true") {
      if (this.loadingFrom === "dashboard") {
        this.jwtService.updateUserPhoneAndStatus(
          this.phoneNumberForm.value.phone,
          "verified",
        );
        this.closeModal.emit("close");
        this.verifyOtpStep3 = false;
        this.showOtpComponent = false;
      } else {
        this.phoneVerifiedSuccess.emit({ status: "true", data: event.data });
      }
    }
  }

  changePhoneNumber(event: string) {
    if (event === "change") {
      this.verifyOtpStep3 = false;
      this.sendOtpStep2 = true;
    }
  }

  clearPhoneServerError() {
    if (this.formError && this.formError.phone) {
      this.formError.phone = "";
    }
    const phoneControl = this.phoneNumberForm.get("phone");
    if (phoneControl && phoneControl.errors && phoneControl.errors.server) {
      const { server, ...remainingErrors } = phoneControl.errors;
      phoneControl.setErrors(
        Object.keys(remainingErrors).length ? remainingErrors : null,
      );
    }
  }

  private setPhoneServerError(message: string) {
    this.formError.phone = message;
    const phoneControl = this.phoneNumberForm.get("phone");
    if (!phoneControl) {
      return;
    }
    const existingErrors = phoneControl.errors || {};
    phoneControl.setErrors({ ...existingErrors, server: true });
    phoneControl.markAsTouched();
  }
}
